import { useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ExportTest = () => {
  const [resultId, setResultId] = useState("");
  const [isExporting, setIsExporting] = useState(false);

  const handleDirectExport = async () => {
    if (!resultId.trim()) {
      toast.error("Please enter a result ID first");
      return;
    }

    setIsExporting(true);
    
    try {
      // Method 1: Direct window.open
      const downloadUrl = `${API}/export-shopify/${resultId.trim()}`;
      window.open(downloadUrl, '_blank');
      toast.success("Download should start automatically!");
    } catch (error) {
      console.error('Export error:', error);
      toast.error("Failed to export CSV file");
    } finally {
      setIsExporting(false);
    }
  };

  const getLatestResult = async () => {
    try {
      // Upload test file to get a result ID
      const formData = new FormData();
      const response = await fetch('/test_manifest.csv');
      const fileBlob = await response.blob();
      const file = new File([fileBlob], 'test_manifest.csv', { type: 'text/csv' });
      
      formData.append('file', file);
      
      const uploadResponse = await fetch(`${API}/upload-manifest`, {
        method: 'POST',
        body: formData,
      });
      
      const result = await uploadResponse.json();
      setResultId(result.id);
      toast.success(`Got result ID: ${result.id.substring(0, 8)}...`);
    } catch (error) {
      console.error('Upload error:', error);
      toast.error("Failed to upload test file");
    }
  };

  return (
    <div className="p-8 bg-white border border-slate-200 rounded-sm space-y-4">
      <h3 className="text-xl font-bold heading-font">Export Test Tool</h3>
      
      <div className="space-y-4">
        <button 
          onClick={getLatestResult}
          className="refinery-button-secondary"
        >
          Generate Test Result ID
        </button>
        
        <div className="flex space-x-2">
          <input
            type="text"
            value={resultId}
            onChange={(e) => setResultId(e.target.value)}
            placeholder="Enter result ID or click Generate above"
            className="flex-1 px-3 py-2 border border-slate-300 rounded-sm mono-font text-sm"
          />
          <button 
            onClick={handleDirectExport}
            disabled={isExporting}
            className="refinery-button flex items-center"
          >
            <Download className="w-4 h-4 mr-2" />
            Download CSV
          </button>
        </div>
        
        {resultId && (
          <div className="space-y-2">
            <p className="text-sm text-slate-600">Direct download links:</p>
            <div className="space-x-2">
              <a 
                href={`${API}/export-shopify/${resultId}`}
                download={`shopify_export_${Date.now()}.csv`}
                className="refinery-button-secondary inline-flex items-center text-sm"
              >
                <Download className="w-3 h-3 mr-1" />
                Method 1: Direct Link
              </a>
              <button 
                onClick={() => window.open(`${API}/export-shopify/${resultId}`, '_blank')}
                className="refinery-button-secondary inline-flex items-center text-sm"
              >
                <Download className="w-3 h-3 mr-1" />
                Method 2: New Window
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExportTest;